export class DocumentLoadDownload {
    userId : number;
    documentLoadId: number;

    constructor(){

    }
}